import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http";
import { Chart } from 'react-google-charts';
import NoData from "../NoData";
import ChartLoader from "../ChartLoader";
import BuketsTable from "../BuketsTable";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates";
import WaterMark from "../../DashboardMain/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar, getElementAtEvent } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
let Maxchartdata

let res_result

export default function OBCMaxTemp({ apiend, gloablfilter }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let barcolor = "#348393"
  let modal_title = "";

  const appyData = (data) => {

    let responce = {
      "<20": 0,
      "30": 0,
      "40": 0,
      "50": 0,
      "60": 0,
      "70": 0,
      "80": 0,
      "90": 0,
      ">=90": 0,
    };

    res_result = data;
    if (res_result.length === 0) {
      setChartData((prestate) => []);
    }
    if (res_result.length != 0 || res_result.OBC_max_Temp.value != null) {
      SetApiResponce(res_result);

      let temp_result = res_result;
      let id = 0
      temp_result.map(d => {
        let value = d.OBC_max_Temp.value;

        if (value >= 0 && value < 20) {
          responce["<20"] = responce["<20"] + 1;
        } else if (value >= 20 && value < 30) {
          responce["30"] = responce["30"] + 1;
        } else if (value >= 30 && value < 40) {
          responce["40"] = responce["40"] + 1;
        } else if (value >= 40 && value < 50) {
          responce["50"] = responce["50"] + 1;
        } else if (value >= 50 && value < 60) {
          responce["60"] = responce["60"] + 1;
        } else if (value >= 60 && value < 70) {
          responce["70"] = responce["70"] + 1;
        } else if (value >= 70 && value < 80) {
          responce["80"] = responce["80"] + 1;
        } else if (value >= 80 && value < 90) {
          responce["90"] = responce["90"] + 1;
        } else if (value >= 90) {
          responce[">=90"] = responce[">=90"] + 1;
        }
      })
      let res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responce);

      loop_keys = ["<20", "30", "40", "50", "60", "70", "80", "90", ">=90"]
      loop_keys.map(x => {
        res_result_final.push([x, responce[x], `{stroke-width: 1;stroke-color: black;color:${barcolor}}`]);
      })
      const labels = ["<20", "30", "40", "50", "60", "70", "80", "90", ">=90"]

      Maxchartdata = {
        labels,
        datasets: [
          {
            label: "Max Battery temp (oC)",
            data: responce,
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },
        ]
      };
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }

  let hAxis = {};

  if (apiend == "OBC_max_temp_slow_chrg_fleet_slow") {
    modal_title = "OBC max temperature - Slow chrg";
    hAxis = {
      gridlines: {
        color: 'transparent'
      },
      title: 'Temperature (Deg cel)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90,
      ticks: ["a", "b", "d", "g", "t", "w", "r", 'P', "Q"]
    };
  }
  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Temperature (Deg cel)'
        },
        suggestedMin: 0,
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Vehicle Count'
        },
        suggestedMin: 0,
        ticks: {
          stepSize: 50,
        },
      },
    },

    plugins: {
      legend: {
        display: false
      },
    }
  }

  const options = {
    hAxis: hAxis,
    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Vehicle Count',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" },
    legend: "none",
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "chargingpage_api/" + apiend, body: { filterdata: gloablfilter } }, appyData)
  }, [gloablfilter])

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">{modal_title}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body  d-flex justify-content-center" style={{ height: "400px" }}>
              {
                (isLoading) ? <ChartLoader /> : ((chartdata.length === 0) ? <NoData /> :
                  <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
                )}
            </div>
          </div>
        </div>
      </div>

      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>

      <WaterMark />
      {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart chartType="ColumnChart" height={203} data={chartdata} options={options} chartEvents={[
        {
          eventName: 'select',
          callback: ({ chartWrapper }) => {
            const chart = chartWrapper.getChart()
            const selection = chart.getSelection()
            if (selection.length === 1) {
              const [selectedItem] = selection;
              const { row } = selectedItem;

              const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
              const count = chartWrapper.getDataTable().Wf[row].c[1].v;
              let filtered_temp = [];
              if (count !== 0) {
                filtered_temp = apiresponce.filter(x => {
                  if (x.OBC_max_Temp.value < barvalue && x.OBC_max_Temp.value >= barvalue - 10) {
                    return x;
                  } else if (x.OBC_max_Temp.value > 90 && barvalue === ">=90") {
                    return x
                  }
                  else if (x.OBC_max_Temp.value < 20 && barvalue === "<20") {
                    return x
                  }
                })

                function compareObjects(object1, object2, key) {
                  const obj1 = object1.OBC_max_Temp.value
                  const obj2 = object2.OBC_max_Temp.value
                  if (obj1 > obj2) {
                    return -1
                  }
                  if (obj1 < obj2) {
                    return 1
                  }
                  return 0
                }

                filtered_temp.sort((value1, value2) => {
                  return compareObjects(value1, value2, 'value')
                })
                SetfilteredData(prestate => filtered_temp);
                window.$('#exampleModal__' + apiend).modal('show');
              }
            }
          }
        }
      ]}
      />)}

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{modal_title}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}>
              <table className="table table-striped">
                <thead style={{ backgroundColor: '#32879c', color: '#fff' }}>
                  <tr>
                    <th scope="col">Vin Number</th>
                    <th scope="col">value</th>
                  </tr></thead>
                <tbody>
                  <BuketsTable data={filteredData} />
                </tbody></table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
